import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import TopBar from "../components/top-bar/TopBar";
import Sidebar from "../components/sidebar/Sidebar";
import PageFooter from "../components/page-footer/PageFooter";

const PageLayout = () => {
  const navigate = useNavigate();

  const [sidebar, setSidebar] = useState(false);

  const handleLoginRedirect = () => navigate("/login");
  const toggleSidebar = () => setSidebar(!sidebar);

  return (
    <>
      <TopBar
        onLoginRedirect={handleLoginRedirect}
        onSidebarToggle={toggleSidebar}
      />
      <Sidebar open={sidebar} onSidebarToggle={toggleSidebar} />

      <Container sx={{ pt: 3 }}>
        <Outlet />
        <PageFooter />
      </Container>
    </>
  );
};

export default PageLayout;
